<button class="icon-chat btn" *ngIf="!showChat && active" (click)="showChat = true"> 
  <img *ngIf="baseData.logo" [src]="baseData.logo" alt="{{baseData.nome}} logo" >
  <span>{{baseData.textoBotao}}</span>
</button>
<div class="chat" *ngIf="showChat && active">
  <section class="chat-sidebar" [ngClass]="{'showFull':showFull}" role="complementary" attr.aria-label="{{baseData.nome}}">
    <!-- Header do chat -->
    <header class="chat-header">
      <img [src]="baseData.logo" alt="{{baseData.nome}} logo" class="chat-logo">
      <span>
        <h2 class="chat-title">{{baseData.nome}}</h2>
        <p class="chat-subtitle">{{baseData.legenda}}</p>
      </span>
      <div class="d-flex">
        <button *ngIf="!showFull && false" class="chat-expand btn font-icon" aria-label="Expandir chat" (click)="showFull = true">open_in_full</button>
        <button *ngIf="showFull && false"  class="chat-expand btn font-icon" aria-label="Retrair chat" (click)="showFull = false">close_fullscreen</button>
        <button class="chat-close btn font-icon" aria-label="Fechar chat" (click)="showChat = false">keyboard_tab</button>
      </div>
    </header>

    <!-- Área principal de mensagens -->
    <main class="chat-messages" #chatMessage role="log" aria-live="polite">
      <ng-container *ngFor="let message of messages; let i = index">
        <div class="card-message"  [style.maxHeight.px]="message.expandido ? null : 200">
          <section class="message" [ngClass]="{'bot-message': message.autor == 'ia', 'user-message': message.autor == 'user'}">
            
            <p  #messageSession *ngIf="message.autor == 'ia'">
              {{message.texto}}
            </p>
            <p #messageSession [innerHTML]="message.texto" *ngIf="message.autor != 'ia'"></p>
            <button *ngIf="message.excedeLimite && !message.expandido" (click)="toggleExpand(i)" class="expand-button">
              {{ message.expandido  ? 'Reduzir' : 'Expandir' }}
            </button>
          </section>
          <button *ngIf="message.autor == 'ia'" class="btn font-icon btn-copy" 
            (click)="copyToClipboard(message.texto, i)">
            <span class="tooltiptext" *ngIf="message.showCopyText">
              Copiado com sucesso!
            </span>
            content_copy</button>
        </div>
        <div *ngIf="message.autor == 'ia'" class="quick-actions">
          <!--<ng-container *ngFor="let option of message.options">
            <button type="button" (click)="setOption(option)" class="btn">
              {{option.pergunta}}
            </button>
          </ng-container>
          <button *ngIf="message?.options?.length > 0" (click)="setVoltar()" class="btn btn-return">
            <span class="font-icon">keyboard_return</span>Voltar
          </button>-->
        </div>
        <section class="card-referencia" *ngIf="(message?.referencia?.length ?? 0) > 0" [style.maxHeight.px]="message.referenciaExpandida ? null : 60">
          <h5>Referências</h5>
          <div [innerHtml]="message?.referencia?.flat()?.join('')" class="referencias"></div>
          <button (click)="toggleExpandReference(i)" class="expand-button">
              {{ message.referenciaExpandida  ? 'Reduzir' : 'Expandir' }}
          </button>
        </section>
      </ng-container>
      <section class="message load-message" *ngIf="idLoading">
        <span>{{currentMsgError}}</span>
        <div class="loader"></div>
      </section>
    </main>

    <!-- Área de input -->
    <footer class="chat-footer">
      <form class="form-message"  *ngIf="currentTopico && currentSubTopico && showTextArea" (ngSubmit)="sendMessage()" (keydown.enter)="handleEnter($event)">
        <textarea #inputMessage
          [(ngModel)]="currentSearch" [ngModelOptions]="{standalone: true}"
          (input)="autoResize($event)" id="chat-text" class="input-message"
          placeholder="Digite aqui sua dúvida"></textarea>
        <button type="submit" class="button-message btn font-icon-rounded" aria-label="Enviar mensagem">near_me</button>
      </form>
      <div *ngIf="!currentTopico && !this.idLoading" class="div-options">
        <button *ngFor="let topico of options" (click)="setTopico(topico)" class="btn btn-option">
          {{topico.rotulo}}
        </button>
      </div>
      <div *ngIf="currentTopico && !currentSubTopico && !this.idLoading" class="div-options">
        <button *ngFor="let subTopico of subTopicos" (click)="setSubTopico(subTopico)" class="btn btn-option">
          {{subTopico.rotulo}}
        </button>
        <button (click)="setVoltar()" class="btn btn-return">
          <span class="font-icon">keyboard_return</span>Voltar
        </button>
      </div>
      <div *ngIf="currentTopico && currentSubTopico && !this.idLoading && !showTextArea" class="quick-actions">
        <ng-container *ngFor="let option of questions">
          <button type="button" (click)="setOption(option)" class="btn">
            {{option.pergunta}}
          </button>
        </ng-container>
        <button (click)="openSupport()" class="btn btn-return">
          <span class="font-icon me-1">edit</span> Pedir ajuda para o suporte
        </button>
      </div>
      
      <div *ngIf="currentTopico && currentSubTopico && !this.idLoading" class="quick-actions">
        <button *ngIf="questions?.length > 0" (click)="setVoltar()" class="btn btn-return">
          <span class="font-icon me-1">keyboard_return</span> Voltar
        </button>
      </div>
      
      <!--<div class="alert-message">
        <small>O {{baseData.nome}} pode cometer erros. Considere verificar informações importantes.</small>
      </div>-->
    </footer>
  </section>
  <div class="chat-background" (click)="closeChat()"></div>
</div>
<template #chat>

</template>